import React, { useState } from "react";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import {
  incrementCurrentSlide,
  incrementPeekSlide,
  setCurrentSlide,
  setPeekSlide,
} from "../../store/slices/slides";
import { setAssessment } from "../../store/slices/assessment";
import { setPopupComponent } from "../../store/slices/ui";
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";
import IconEdit from "../../images/icn-edit.svg";

const validationSchema = Yup.object({
  firstName: Yup.string().required("First name is required"),
  lastName: Yup.string().required("Last name is required"),
  dob: Yup.string()
    .matches(
      /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/,
      "Date of Birth should be in MM/DD/YYYY format"
    )
    .required("Date of Birth is required"),
});

function MyAccount({ isVisible }) {
  const dispatch = useDispatch();
  const { user } = useAuth0();
  const { data: assessment } = useSelector((state) => state.assessment);
  const [editingFields, setEditingFields] = useState({
    firstName: false,
    lastName: false,
    dob: false,
  });
  const [isSubmitting, setSubmitting] = useState();

  const handleSubmit = async (values) => {
    setSubmitting(true);

    try {
      await axios.put("RetailAssessmentUserUpdate", {
        ...values,
        sub: user.sub,
      });
      dispatch(setAssessment({ ...assessment, patient: values }));
      setEditingFields({
        firstName: false,
        lastName: false,
        dob: false,
      });
    } catch (e) {
      console.log(e);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="h-full bg-get-started">
      <div className="block-emotti">
        <div className="block-welcome">
          <h1 class="">
            My Account{" "}
            <a
              href="#"
              class="btn btn-white float-right"
              onClick={() => {
                dispatch(setPeekSlide(0));
                dispatch(setCurrentSlide(0));
              }}
            >
              {" "}
              Back{" "}
            </a>
          </h1>
          <Formik
            initialValues={{
              firstName: assessment?.patient?.firstName || "",
              lastName: assessment?.patient?.lastName || "",
              dob: assessment?.patient?.dob || "",
            }}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
            enableReinitialize
          >
            {({ isValid }) => (
              <Form>
                <div className="p-2 py-5 gap-3 grid">
                  <label className="block my-account-box">
                    <span className="form-label">Update First Name</span>
                    <Field
                      type="text"
                      name="firstName"
                      className="form-control"
                      placeholder=""
                      disabled={!editingFields.firstName}
                    />
                    <span
                      class="icn-edit-field cursor-pointer"
                      onClick={() =>
                        setEditingFields((k) => ({
                          ...k,
                          firstName: !k.firstName,
                        }))
                      }
                    >
                      <img src={IconEdit} alt="" id="first_name" />
                    </span>
                    <ErrorMessage
                      name="firstName"
                      component="div"
                      className="text-red-300"
                    />
                  </label>

                  <label className="block my-account-box">
                    <span className="form-label">Update Last Name</span>
                    <Field
                      type="text"
                      name="lastName"
                      className="form-control"
                      placeholder=""
                      disabled={!editingFields.lastName}
                    />
                    <span
                      class="icn-edit-field cursor-pointer"
                      onClick={() =>
                        setEditingFields((k) => ({
                          ...k,
                          lastName: !k.lastName,
                        }))
                      }
                    >
                      <img src={IconEdit} alt="" id="first_name" />
                    </span>

                    <ErrorMessage
                      name="lastName"
                      component="div"
                      className="text-red-300"
                    />
                  </label>

                  <label className="block my-account-box">
                    <span className="form-label">Update Date of Birth</span>
                    <Field
                      type="text"
                      name="dob"
                      className="form-control"
                      placeholder=""
                      disabled={!editingFields.dob}
                    />
                    <span
                      class="icn-edit-field cursor-pointer"
                      onClick={() =>
                        setEditingFields((k) => ({
                          ...k,
                          dob: !k.dob,
                        }))
                      }
                    >
                      <img src={IconEdit} alt="" id="first_name" />
                    </span>
                    <ErrorMessage
                      name="dob"
                      component="div"
                      className="text-red-300"
                    />
                  </label>

                  {(editingFields?.firstName ||
                    editingFields?.lastName ||
                    editingFields?.dob) && (
                    <div className="tex-center flex justify-start pt-5">
                      <button
                        type="submit"
                        className={`btn btn-green ${
                          !isValid || isSubmitting
                            ? "cursor-default opacity-50 pointer-events-none"
                            : ""
                        }`}
                        disabled={!isValid || isSubmitting}
                      >
                        Save Changes
                      </button>
                      <button className="btn btn-green-brder">Cancel</button>
                    </div>
                  )}
                </div>
              </Form>
            )}
          </Formik>

          <div className="close-account">
            <h4>Account closure</h4>
            <p>
              Account closure is permanent and irreversible. Please read terms
              before proceeding.
            </p>
            <a
              onClick={() => dispatch(setPopupComponent("CloseAccount"))}
              href="#"
              className="btn-close-account"
            >
              Close account
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MyAccount;
